"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Policy = void 0;
class Policy {
}
exports.Policy = Policy;
//# sourceMappingURL=Policy.js.map